import mapboxgl from './mapboxgl';
var setRTLTextPlugin = mapboxgl ? mapboxgl.setRTLTextPlugin : function () {};
export default setRTLTextPlugin;
//# sourceMappingURL=set-rtl-text-plugin.js.map